const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.25 4.75A.75.75 0 0 1 4 4h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75m3 10.5A.75.75 0 0 1 7 14.5h4.25v-4.25a.75.75 0 0 1 1.5 0v4.25H17a.75.75 0 0 1 0 1.5h-4.25v4.25a.75.75 0 0 1-1.5 0V16H7a.75.75 0 0 1-.75-.75"/></svg>';
export {
  a as w
};
